import { SimpleFetch, userStatus, history } from '../../../../_helpers'

const user = userStatus();

export const formSubmit = async (domain, managerLocalData, managerComponentsData) => {
  if (
    !managerComponentsData.trigger[0].comparation ||
    !managerComponentsData.trigger[0].value.length === 0
  ) return false;

  const momentums = [];
  Object.entries(managerComponentsData).forEach(objectItem => {
    momentums.push({type: objectItem[0], values: objectItem[1]});
  });

  const worktime = ( ( data ) => {
    if ( !data.worktime ) return undefined
    const areWeekDays = !!data.worktime.weekdays?.length
    const areStartAt = !!data.worktime.start_at
    const areStopAt = !!data.worktime.stop_at
    const areEvery = areWeekDays && areStartAt && areStopAt

    if ( areEvery ) return data.worktime

    return undefined
  } )( managerLocalData )

  const obj = {
    company_uuid: user.company_uuid ? user.company_uuid : JSON.parse(sessionStorage.getItem('cellit_userdata')).company_uuid,
    domain_uuid: domain,
    user_uuid: user.user_uuid ? user.user_uuid : JSON.parse(sessionStorage.getItem('cellit_userdata')).user_uuid,
    type: "dcm",
    momentum_title: managerLocalData.momentum_title,
    momentum_description: managerLocalData.momentum_description ? managerLocalData.momentum_description : "",
    status: managerLocalData.shouldSchedule ? "Paused" : "Active",
    scheduled_at: managerLocalData.shouldSchedule ? managerLocalData.scheduled_at : null,
    momentums,
    worktime
  }

  const res = await SimpleFetch(`POST`, {}, obj, `momentum`, `momentum/create/`);
  if ( res.status !== 200 ) return;

  history.push('/dcm');
}